// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1PN2i","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1gQ19"};